module.exports = __webpack_public_path__ + "static/media/4.e99ec433.jpeg";